var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtractAcronyms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 811.85h43v2h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 800.85h43v3h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 826.85h43v3h-43z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 806.85h19v2h-19z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 821.85h35v3h-35z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "ean_cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469 816.85h30v3h-30z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.ean_s0 { opacity: .3;fill: #4e5766 } \n\t\t.ean_s1 { fill: #ffffff } \n\t\t.ean_s2 { fill: none;stroke: #533ffb;stroke-miterlimit:100;stroke-width: 2 } \n\t\t.ean_s3 { fill: #533ffb } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ean_icon-workspace-task-extract-acronyms",
    clipPath: "url(#ean_cp1)",
    transform: "translate(-433 -792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 7779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 12354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 6737",
    clipPath: "url(#ean_cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 7142",
    className: "ean_s0",
    d: "m464.1 806.4h53.8v11.1h-53.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 6738",
    clipPath: "url(#ean_cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 7144",
    className: "ean_s0",
    d: "m462 793.9h56v18h-56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 6740",
    clipPath: "url(#ean_cp4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 7148",
    className: "ean_s0",
    d: "m464 820.9h54v14h-54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 6741",
    clipPath: "url(#ean_cp5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 7150",
    className: "ean_s0",
    d: "m462 799.9h32v17h-32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 6742",
    clipPath: "url(#ean_cp6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 7152",
    className: "ean_s0",
    d: "m462 814.9h47v18h-47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ean_Group 12352",
    clipPath: "url(#ean_cp7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ean_Rectangle 8470",
    className: "ean_s0",
    d: "m463 808.9h42v18h-42z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ean_Ellipse 52",
    className: "ean_s1",
    d: "m454 836.9c-12.2 0-22-9.9-22-22 0-12.2 9.8-22 22-22 12.2 0 22 9.8 22 22 0 12.1-9.8 22-22 22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ean_Ellipse 53",
    className: "ean_s2",
    d: "m455 833.9c-11.1 0-20-9-20-20 0-11.1 8.9-20 20-20 11.1 0 20 8.9 20 20 0 11-8.9 20-20 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ean_Path 14263",
    fillRule: "evenodd",
    className: "ean_s3",
    d: "m441.6 820.8l5.9-16h2l5.8 16h-2l-1.6-4.6h-6.5l-1.6 4.6zm9.5-6.3l-2.5-7.2h-0.2l-2.5 7.2zm5.9 2.9c0-2.8 2.4-3.3 4.6-3.6 2.2-0.2 3.1-0.2 3.1-1v-0.1c0-1.5-0.8-2.4-2.5-2.4-1.8 0-2.7 0.9-3.1 1.8l-1.8-0.6c1-2.2 3-2.9 4.8-2.9 1.6 0 4.5 0.5 4.5 4.3v7.9h-1.9v-1.7h-0.1c-0.3 0.8-1.4 1.9-3.5 1.9-2.3 0-4.1-1.3-4.1-3.6zm7.7-1v-1.6c-0.3 0.3-2.4 0.5-3.2 0.6-1.4 0.2-2.7 0.7-2.7 2.1 0 1.2 1.1 1.9 2.6 1.9 2.1 0 3.3-1.5 3.3-3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractAcronyms);
export default __webpack_public_path__ + "static/media/extract-acronyms.31ab7e3b5a4c7ea9c3b6a92506e063f2.svg";
export { ForwardRef as ReactComponent };